module.exports = __webpack_public_path__ + "img/blog-grid-light.b2ac831a.png";